module.exports = __webpack_public_path__ + "img/VIMOQR1.a3a1f4fb.svg";